<template>
	<AppTextField
		outlined
		single-line
		hide-details
		ref="input_search"
		placeholder="Search"
		class="search-field"
		v-model="localSearchString"
		prepend-inner-icon="mdi-magnify"
	/>
</template>
<script>
import debounce from 'lodash/debounce';
export default {
	name: 'SelectFavoriteAppsMenuSearch',
	props: {
		searchString: { type: String },
	},
	computed: {
		localSearchString: {
			get() {
				return this.searchString;
			},
			set: debounce(function (value) {
				this.$emit('update:searchString', value);
			}, 300),
		},
	},
	methods: {
		focus() {
			// Triggered from parent
			this.$refs.input_search.focus();
		},
	},
	mounted() {
		setTimeout(() => {
			this.focus();
		}, 500);
	},
};
</script>

<style scoped lang="scss">
.search-field {
	$height: 35px;
	&::v-deep {
		.v-icon {
			font-size: 18px !important;
		}
		&.v-text-field .v-input__control .v-input__slot {
			min-height: $height !important;
			max-height: $height !important;
		}
	}
}
</style>
